import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import CardHeader from "components/Card/CardHeader.js";
import Info from "components/Typography/Info.js";

import blogsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/blogsStyle.js";
import a1 from "assets/img/a1.png";
import a2 from "assets/img/a2.png";
import a3 from "assets/img/a3.png";

const useStyles = makeStyles(blogsStyle);

export default function SectionBlogs({ ...rest }) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>
      {/* Blogs 1 START */}
      <div className={classes.blog}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={10}
              md={10}
              className={classes.mlAuto + " " + classes.mrAuto}
            >
              <h2
                className={classes.title}
                style={{
                  fontFamily: "Kanit",
                  fontWeight: "bold",
                }}
              >
                เกี่ยวกับเรา
              </h2>
              <br />
              <Card plain blog className={classes.card}>
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <a href="#pablito" onClick={(e) => e.preventDefault()}>
                        <img
                          src={a1}
                          alt="ร้านเสื้อยืดเมอร์คิวรี่ ทีเชิ้ต ขายปลีก-ส่งเสื้อยืดสีพื้น และเสื้อสกรีน"
                        />
                      </a>
                      <div
                        className={classes.coloredShadow}
                        style={{
                          backgroundImage: `url(${a1})`,
                          opacity: "1",
                        }}
                      />
                    </CardHeader>
                  </GridItem>
                  <GridItem xs={12} sm={7} md={7}>
                    <Info>
                      <h6
                        className={classes.cardCategory}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เกี่ยวกับเรา
                      </h6>
                    </Info>
                    <h3 className={classes.cardTitle}>
                      <a
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เมอร์คิวรี่ ทีเชิ้ต
                      </a>
                    </h3>
                    <p className={classes.description1}>
                      ร้านเสื้อยืดเมอร์คิวรี่ ทีเชิ้ต ขายปลีก-ส่งเสื้อยืดสีพื้น
                      และเสื้อสกรีน สินค้าผลิตจากในไทย มีพร้อมจัดส่งทันที
                      การันตีรับประกันสินค้าคุณภาพ ติดต่อร้านได้ง่าย
                      มีแอดมินดูแล 24 ชั่วโมง
                      <br />
                      เสื้อยืดของเรามีทั้งหมดกว่า 20 สี
                      มีทั้งคอกลมและคอวีสินค้าเป็นทรงตรงสามารถใส่ได้ทั้งผู้หญิงและผู้ชาย
                      <br />
                      <a
                        href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                        style={{ color: "#E91E63" }}
                      >
                        Line@ : @mercurytshirt.com
                      </a>
                    </p>
                  </GridItem>
                </GridContainer>
              </Card>
              <Card plain blog className={classes.card}>
                <GridContainer>
                  <GridItem xs={12} sm={7} md={7}>
                    <Info>
                      <h6
                        className={classes.cardCategory}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เกี่ยวกับเรา
                      </h6>
                    </Info>
                    <h3 className={classes.cardTitle}>
                      <a
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เมอร์คิวรี่ ทีเชิ้ต
                      </a>
                    </h3>
                    <p className={classes.description1}>
                      “เสื้อยืดสีเอิร์ธโทร” ถือเป็นสีเบสิคสำหรับการแต่งตัว
                      ด้วยโทรสีที่ไม่ฉูดฉาดแถมให้ความสบายตา
                      จึงเป็นสีที่ใครใส่ก็รอด ดูดีมีความมินิมอล
                      เสื้อยืดโทนนี้ทางร้านขายส่งตั้งแต่20ตัวขึ้นไป
                      เป็นเนื้อผ้าคอตตอนผสม รับประกันความสวยของเนื้อผ้า
                      และเนื้อผ้าไม่หดอย่างแน่นอน เหมาะสำหรับใส่ในวันสบายๆ
                      และเหมาะกับอากาศของประเทศไทย
                      <br />
                      <a
                        href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                        style={{ color: "#E91E63" }}
                      >
                        Line@ : @mercurytshirt.com
                      </a>
                    </p>
                  </GridItem>
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <a href="#pablito" onClick={(e) => e.preventDefault()}>
                        <img src={a2} alt="เสื้อยืดสีเอิร์ธโทร" />
                      </a>
                      <div
                        className={classes.coloredShadow}
                        style={{
                          backgroundImage: `url(${a2})`,
                          opacity: "1",
                        }}
                      />
                    </CardHeader>
                  </GridItem>
                </GridContainer>
              </Card>
              <Card plain blog className={classes.card}>
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <a href="#pablito" onClick={(e) => e.preventDefault()}>
                        <img src={a3} alt="เสื้อยืดคอกลมเด็ก" />
                      </a>
                      <div
                        className={classes.coloredShadow}
                        style={{
                          backgroundImage: `url(${a3})`,
                          opacity: "1",
                        }}
                      />
                    </CardHeader>
                  </GridItem>
                  <GridItem xs={12} sm={7} md={7}>
                    <Info>
                      <h6
                        className={classes.cardCategory}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เกี่ยวกับเรา
                      </h6>
                    </Info>
                    <h3 className={classes.cardTitle}>
                      <a
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          fontFamily: "Kanit",
                          fontWeight: "bold",
                        }}
                      >
                        เมอร์คิวรี่ ทีเชิ้ต
                      </a>
                    </h3>
                    <p className={classes.description1}>
                      “เสื้อยืดคอกลมเด็ก”
                      เสื้อที่ดีและเหมาะสมกับวัยเด็กคงหนีไม่พ้น
                      เสื้อยืดที่มีคุณภาพดี นุ่มลื่น ระบายอาศได้ดี
                      แถมต้องมีสีสรรสดใสเหมาะกับวัยนี้
                      ทางร้านขอนำเสนอเสื้อยืดสีพื้นเด็ก
                      ใส่ได้ทั้งเด็กผู้หญิงและผู้ชาย
                      สีพื้นเรียบๆเหมาะที่จะสวมใส่ในประเทศเขตร้อนอย่างประเทศไทย
                      เนื้อผ้าฝ้าย100% ของเสื้อจะทำให้เด็กไม่ร้อน
                      และทำกิจกรรมได้อย่างคล่องตัวตามวัยอย่างสบายตัวสบายใจ
                      <br />
                      <a
                        href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                        style={{ color: "#E91E63" }}
                      >
                        Line@ : @mercurytshirt.com
                      </a>
                    </p>
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Blogs 1 END */}
    </div>
  );
}
